module.exports = __webpack_public_path__ + "87f258b28fb0643350a47b28c2e86a77.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/wasistgoldencity.jpg
// module id = 912
// module chunks = 0